import { render, staticRenderFns } from "./LoginFooter.vue?vue&type=template&id=b11210dc&"
import script from "./LoginFooter.vue?vue&type=script&lang=js&"
export * from "./LoginFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports